import React, { useEffect, useState } from 'react';
import { readDoctors, MAX_DOCTORS } from './fontStyle';
import './ReportLayout.css';

// Doctor records from Template Settings, shown above the report footer.
// Templates place it inside a .report-page-bottom group (see ReportLayout.css).
// At most MAX_DOCTORS doctors are shown. When `phone` is given, the lab's
// phone number is shown right below the doctors.
// Renders nothing when there is no doctor and no phone.
const DoctorInfo = ({ fontFamily, accentColor = '#0284c7', phone, style }) => {
  const [drs, setDrs] = useState([]);

  useEffect(() => {
    setDrs(readDoctors().slice(0, MAX_DOCTORS));
  }, []);

  if (drs.length === 0 && !phone) return null;

  return (
    <div
      className="report-doctor-info-group"
      style={{ margin: '16px 0', fontFamily, pageBreakInside: 'avoid', breakInside: 'avoid', ...style }}
    >
      {drs.length > 0 && (
        <div
          className="report-doctor-info"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${drs.length}, 1fr)`,
            gap: '12px',
            textAlign: 'center',
          }}
        >
          {drs.map((doc, idx) => (
            <div key={doc.drid || idx} style={{ padding: '8px 4px', borderTop: '1px dashed #cbd5e1' }}>
              <div style={{ fontWeight: '700', fontSize: '12px', color: '#0f172a' }}>{doc.drname}</div>
              {doc.designation && (
                <div style={{ color: accentColor, fontSize: '10px', fontWeight: '500' }}>{doc.designation}</div>
              )}
              {doc.description && (
                <div style={{ color: '#64748b', fontSize: '10px', whiteSpace: 'pre-line' }}>{doc.description}</div>
              )}
              {doc.address && (
                <div style={{ color: '#64748b', fontSize: '10px' }}>{doc.address}</div>
              )}
            </div>
          ))}
        </div>
      )}
      {phone && (
        <div
          className="report-doctor-phone"
          style={{ textAlign: 'center', fontSize: '11px', color: '#0f172a', marginTop: drs.length > 0 ? '4px' : 0 }}
        >
          <span style={{ fontWeight: 600 }}>Phone:</span> {phone}
        </div>
      )}
    </div>
  );
};

export default DoctorInfo;
